<template>
    <section class="contenedor-tarifas">
        <div class="botonera-tarifas container">
            <button v-if="getTarifas(suministro, tarifa.id)" class="btn" :class="tarifaActiva == tarifa.id ? '-degree' : '-skull-orange -gray-ce'"
                :style="tarifa.btn.includes('<br>') ? 'line-height: 20px;' : ''"
                v-for="tarifa in tarifas" :key="tarifa.id" @click="activarTarifa(tarifa.id)" v-html="tarifa.btn">
            </button>
        </div>
    </section>
</template>

<script lang="js">
import { mapGetters } from 'vuex';

export default {
    name: 'botonera-tarifas',
    props: ['tarifas', 'tarifaActiva', 'suministro'],
    methods: {
        activarTarifa(id) {
            this.$emit('activarTarifa', id);
        },
        getTarifas(suministro,type) {
            if (!!this.precios) {
                // Traducción: precioCoste usa los precios de clasica
                let tarifaType = type;
                switch (type) {
                    case 'precioCoste':
                        tarifaType = 'clasica';
                        break;
                    case 'CEprecioFijo':
                    case 'CEprecioCoste':
                        tarifaType = 'cocheElectrico';
                        break;
                    case '3.0precioFijo':
                    case '3_0TDprecioCoste':
                    case '3.0precioCoste':
                        tarifaType = '3_0TD';
                        break;
                    case '6.1precioFijo':
                    case '6_1precioCoste':
                    case '6.1precioCoste':
                        tarifaType = '6_0';
                        break;
                }
                return this.precios[`tarifas_${suministro}`][tarifaType];
            }
        }
    },
    computed: {
        ...mapGetters({
            precios: 'getPrecios',
        })
    }
}
</script>

<style scoped lang="scss">
.contenedor-tarifas {
    background-color: #f6a9101c;
    padding: 40px 0;
    margin-bottom: 80px;
}

.botonera-tarifas {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
}

.btn {
    height: auto !important;
    min-height: 65px;
}

@media screen and (max-width:650px) {
    .contenedor-tarifas {
        display: none;
    }

    .botonera-tarifas {
        flex-direction: column;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/parts/botonera-tarifas.vue